import { observable, runInAction } from "mobx"


import { displayName, displayPath } from "@/lib/displayUtils.ts"
import { Model } from "@/lib/Model.ts"

import type { GitFile, InlineDiff } from "@/lib/client/generated/TypeDefinitions.ts"

export type GitCommitChangeMin = {
  old: Pick<GitFile, "path"> | null
  new: Pick<GitFile, "path"> | null
}

export class DiffFileModel extends Model {
  readonly isCollapsed = observable.box(false)

  readonly file: GitCommitChangeMin
  readonly diff: InlineDiff | null
  readonly added: number
  readonly deleted: number
  readonly isCollapsible: boolean
  readonly close?: () => void

  constructor(params: {
    file: GitCommitChangeMin
    diff: InlineDiff | null

    isCollapsed?: boolean,
    isCollapsible?: boolean
    close?: () => void
  }) {
    super("DiffFileModel")

    this.diff = params.diff
    this.file = params.file
    this.isCollapsible = params.isCollapsible !== false
    this.added = this.diff ? this.diff?.lines.filter(it => it.type === "ADDED" || it.type === "MODIFIED").length ?? 0 : 0
    this.deleted = this.diff ? this.diff?.lines.filter(it => it.type === "DELETED" || it.type === "MODIFIED").length ?? 0 : 0
    this.close = params.close

    runInAction(() => {
      this.isCollapsed.set(params.isCollapsed || false)
    })
  }

  get path() {
    return this.file.new?.path || this.file.old?.path || ""
  }

  get fileName() {
    return displayName(this.path)
  }

  get filePath() {
    return displayPath(this.path)
  }

  readonly toggleCollapse = () => runInAction(() => {
    if (this.isCollapsible) {
      runInAction(() => this.isCollapsed.set(!this.isCollapsed.get()))
    }
  })
}